export default class EPGConfig {
    static ChannelRowHeight = 110
    static ChannelWidth = 110
    static RowLabelWidth = 291
    static RowLabelItemHeight = 77  // 500px / 6.5 visible rows ≈ 77px
    static pixelPer30m = 470
    static pixelPerHour = 470*2
}
